import React from "react";
import axios from "axios";
import { Typography } from "@mui/material";
import { C, D } from "../include";
import { Paper, Stepper, Step, StepLabel, StepContent, Button, Snackbar, Dialog, DialogTitle, DialogContent, TextField, FormControl, InputLabel, Select, MenuItem, Stack, FormControlLabel, DialogActions, Checkbox, Divider } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { Close, FamilyRestroom, MedicalServices } from "@mui/icons-material";
import { QuestionRadioButton, QuestionSlidebar, QuestionCheckbox, QuestionEditbox } from "./Survey"

class ColectData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      foundHash: false,
      hash: null,
      company: "",
      companyID: -1,
      treatment: "",
      treatmentID: -1,
      questionnaireID: -1,
      patientID: -1,
      price: "R$ ",
      training_patient: false,      
      activeStep: 0,
      ip: '',
      snackbar: false,
      snackbarMsg: "",
      dialogOpen: false,
      dialogChildren: [],
    };
    this.api = axios.create({ baseURL: C.baseURL });
  }
  
  
  
  steps = [
    {
      label: 'Dados cadastrais',
      description: 'Informe sua identificação, idade, endereço, contatos, responsável legal (quando menor de idade). Estes dados são utilizados para ficha de histórico do paciente, contatos em caso de necessidade e confecção do contrato de prestação de serviços.',
    },
    {
      label: 'Pré-anamnese',
      description: 'O objetivo é obter informações sobre a saúde da pessoa, pois ajuda o profissional de saúde a entender a história clínica do paciente.',
    },
  ];
  
  
  componentDidMount() {
    //http://10.18.166.55:9000/candidate?r=aassddff
    const searchParams = new URLSearchParams(document.location.search)
    var hash = searchParams.get('r');
    
    if(hash == null){
      this.setState({ foundHash: false });
      return;
    }    
  
    this.setState({ loading: true });    
    axios
      .get(C.baseURL + "candidate/" + hash, null)
      .then((r) => {
        this.setState({
          hash: hash,         
          foundHash: r.data.foundHash,
          company: r.data.company,
          companyID: parseInt(r.data.companyID),
          treatment: r.data.treatment,
          treatmentID: parseInt(r.data.treatmentID),
          questionnaireID: parseInt(r.data.questionnaireID),
          patientID: r.data.patientID ? parseInt(r.data.patientID) : -1,
          price: r.data.price,
          training_patient: r.data.training_patient,
          activeStep: parseInt(r.data.activeStep),
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
      
    this.getIP();
  }
  
  
  getIP = async () => {
    await axios.get("https://api.ipify.org/?format=json")
    .then((r) => {
      this.setState({ip: r.data.ip});
    });
  };
  
  alert = (message) => {
    this.setState({snackbar: true, snackbarMsg: message});
  };
  
  dialog = (m) => this.setState({ dialogOpen: true, dialogChildren: m });

  dialogClose = () => this.setState({ dialogOpen: false, dialogChildren: [] });
  
  
  handleNext = () => {
    if(this.state.activeStep === 0){   //Dados Cadastrais       
      this.dialog(
           <EditPatient
               edit={false}
               row={null}
               api={this.api}
               alert={this.alert}
               dialogClose={() => {
                   this.dialogClose();
               }}
               user={ {company_id: this.state.companyID, role: "anonymous", hash: this.state.hash, ip: this.state.ip} }
           />
      )          
    }
    else if(this.state.activeStep === 1){  //Anamnese
      this.dialog(
           <Survey
               patient_id={this.state.patientID}
               procedure_id={-1}
               questionnaire_id={this.state.questionnaireID}
               company_id={this.state.companyID}
               document_type={1}
               treatment_id={this.state.treatmentID}
               training_patient={this.state.training_patient}
               price={this.state.price}
               api={this.api}
               alert={this.alert}
               dialogClose={() => {
                   this.dialogClose();
               }}
               hash={this.state.hash}
               ip={this.state.ip}
           />
      )    
    }
  };

  
  render() {
    return (
    <D className="col e aF scD" style={{ padding: '2rem', backgroundColor: "#424242" }}>
      
      <D style={{ display: 'table', textAlign: "center" }} ><img style={{ width: "25%", height: "25%" }} src={C.coverImg} alt="logo" /></D>
      <Typography variant='h5' color="white" textAlign="center">{this.state.company}</Typography>
    
      {this.state.foundHash &&
      <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden', padding: '1rem' }}>
        <Typography variant="subtitle1"><strong>Procedimento</strong>: {this.state.treatment}</Typography>
        <Typography variant="subtitle1"><strong>Paciente-modelo</strong>: {this.state.training_patient ? "Sim" : "Não"}</Typography>
        <Typography variant="subtitle1"><strong>Valor</strong>: {this.state.price}</Typography>
        <D h="1rem" />
            

      <Stepper activeStep={this.state.activeStep} orientation="vertical">
        {this.steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel optional={ index === this.steps.length - 1 ? (<Typography variant="caption">Passo final</Typography>) : null }>
              {step.label}
            </StepLabel>
            <StepContent>
              <Typography>{step.description}</Typography>
                <Button
                  variant="contained"
                  onClick={this.handleNext}
                  sx={{ mt: 1, mr: 1 }}
                >
                  {index === this.steps.length - 1 ? 'Avançar' : 'Avançar'}
                </Button>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      
        {this.state.activeStep === this.steps.length && (
          <Paper square elevation={0} sx={{ p: 3 }}>
            <Typography>Todos os passos foram preenchidos - você terminou.</Typography>
          </Paper>
        )}        
      </Paper> 
      }
      
      {!this.state.foundHash &&
        <D>
          <D h="2rem" />
          <Typography variant='h4' color="white" textAlign="center">Busca da URL</Typography>
        </D>
      }
      <Dialog open={this.state.dialogOpen} onClose={this.dialogClose} >
          {this.state.dialogChildren} 
      </Dialog>
      <Snackbar
        open={this.state.snackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        action={<Close onClick={() => this.setState({snackbar: false})} />}
        message={this.state.snackbarMsg}
        onClose={() => this.setState({snackbar: false})}
      />
      </D>

    );
  }
}











/***************************************************************************************
 ***************************************************************************************
 
 From Patient.jsx - avoid import and usage of authenticated API
 
 ***************************************************************************************
***************************************************************************************/


function computeAge(birthday){
    var age = 18;
    if(birthday){
      //Converte DD/MM/YYYY em um Date object
      let [day, month, year] = birthday.split('/')
      const birthdayObj = new Date(+year, +month - 1, +day)
      
      var diff_ms = Date.now() - birthdayObj; //difference in milliseconds
      var age_dt = new Date(diff_ms); 
      age = Math.abs(age_dt.getUTCFullYear() - 1970); //difference in years between the age Date object and the year 1970 (UNIX epoch)
    }    
    return age;
}
  
  
class EditPatient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      name: '',
      company_id: this.props.user.company_id,
      birthday: new Date().toISOString().substring(0, 10),
      gender: -1,
      mobile: "",
      mobile2: "",
      email: "",
      cep: "",
      address: "",
      city: "",
      state: "",
      cpf: "",
      profession: "",
      maritalstatus: -1,
      idt_front_file: -1,
      idt_back_file: -1,
      previous_idt_front_file: -1,
      previous_idt_back_file: -1,
      allow_contact: true,
      invalid_cpf: false,
      invalid_cpf_legalrepresentative: false,
      doctor: "Não há",
      doctor_phone: "(00) 00000-0000",
      emergencyname: "Não há",
      emergencyphone: "(00) 00000-0000",
      health_insurance: "Não há",
      card: "Não há",
      hospital: "Não há",      
      legalcity: " ",
      legalcpf: " ",
      legalmaritalstatus: -1,
      legalname: " ",
      legalprofession: " ",
      legalstate: " ",
      age: 18,
      lat: '',
      long: '',
    };
  }


  handleSubmit = () => {
    if (this.state.invalid_cpf || this.state.invalid_cpf_legalrepresentative) return;
    
    this.props.api
      .post("candidate_step1/" + this.props.user.hash + "/" + this.props.user.ip, { name: this.state.name, company_id: this.state.company_id, birthday: this.state.birthday, gender: this.state.gender, mobile: this.state.mobile, mobile2: this.state.mobile2, email: this.state.email, cep: this.state.cep, address: this.state.address, city: this.state.city, state: this.state.state, cpf: this.state.cpf, profession: this.state.profession, maritalstatus: this.state.maritalstatus, idt_front_file: this.state.idt_front_file, idt_back_file: this.state.idt_back_file, allow_contact: this.state.allow_contact,doctor: this.state.doctor, doctor_phone: this.state.doctor_phone, emergencyname: this.state.emergencyname, emergencyphone: this.state.emergencyphone, health_insurance: this.state.health_insurance, card: this.state.card, hospital: this.state.hospital, legalcity: this.state.legalcity, legalcpf: this.state.legalcpf, legalmaritalstatus: this.state.legalmaritalstatus, legalname: this.state.legalname, legalprofession: this.state.legalprofession, legalstate: this.state.legalstate, latitude: this.state.lat, longitude: this.state.long })
      .then((r) => {
        this.props.dialogClose();
        if("error" in r)
          this.props.alert(r.error);
        else
          this.props.alert('Cadastro realizado com sucesso');
      })
      .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
  };


  
  cpfMask = (value, patient) => {
    var theRet = value
      .replace(/\D/g, '') // substitui qualquer caracter que não seja número por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de número, o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 núumeros seguidos de um traço e não deixa ser digitado mais nada
    
    //Valida o CPF
    if(theRet.length === 14){
      var strCPF = theRet.replace(/\D/g, '')
      var invalidCPF = false;
      var Soma, Resto;
      Soma = 0;
      if (strCPF === "00000000000") invalidCPF = true;

      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11))  Resto = 0;
      if (Resto !== parseInt(strCPF.substring(9, 10)) ) invalidCPF = true;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11))  Resto = 0;
      if (Resto !== parseInt(strCPF.substring(10, 11) ) ) invalidCPF = true;
      if(patient)
        this.setState({invalid_cpf: invalidCPF});
      else
        this.setState({invalid_cpf_legalrepresentative: invalidCPF});
    }
    
    return theRet
  }
  
  phoneMask = (value) => {
    return value
      .replace(/\D+/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2') // Trata o caso de um número fixo de telefone, que tem 8 números
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3') //Trata o caso de um número de celular, que tem 9 números
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  cepMask = (value) => {
    var theRet = value
      .replace(/\D+/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1')
    
    //Valida o CEP
    if(theRet.length === 9){
      var strCEP = theRet.replace(/\D/g, '')      
      fetch(`https://viacep.com.br/ws/${strCEP}/json/`)
        .then((res) => res.json())
        .then((data) => {
           if(this.state.address === "") this.setState({address: data.logradouro}) 
           if(this.state.city === "") this.setState({city: data.localidade})
           if(this.state.state === "") this.setState({state: data.uf})
        })
        .catch(error => {
           //console.log(error);
           this.props.alert("Busca de CEP nos Correios falhou")
        });
        
        var lat='', long='';
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${strCEP}|country:BR&key=AIzaSyB_WwYj9ufkKkGhnXv7XkEpL4rf4bweqQU`)
        .then((res) => res.json())
        .then((data) => {
           if(data.results.length > 0)
             if("geometry" in data.results[0])
               if("location" in data.results[0]["geometry"])
                 if(("lat" in data.results[0]["geometry"]["location"]) && ("lng" in data.results[0]["geometry"]["location"])){
                   lat = String(data.results[0]["geometry"]["location"]["lat"])
                   long = String(data.results[0]["geometry"]["location"]["lng"])    
                 }           
        })
        .catch(error => {
           //console.log(error);
           this.props.alert("Busca de Lat Long no Google Maps falhou")
        })
        .finally(() => {
          this.setState({lat: lat,long: long});
        });
        
    }
    
    return theRet;
  }

  handleDateChange = (e) => {
    var strDate = "" + ( (e.$D)>9 ? e.$D : "0"+e.$D )+ "/" + ( (e.$M+1)>9 ? (e.$M+1) : "0"+(e.$M+1) )+ "/" + e.$y;
    this.setState({ birthday: strDate, age: computeAge(strDate) });
  }
  

  handleDBRecord = (record, error, side) => {
    if(!error){
      if(side === "frente")
        this.setState({idt_front_file: record.id });
      else if(side === "verso")
        this.setState({idt_back_file: record.id });
    }
  }
  
 
  
  render() {
    return (
      <form onSubmit={this.handleSubmit} method="GET">
         <input type="hidden" name="r" value={this.props.user.hash}/>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Paciente' : 'Adicionar Paciente'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          {(this.props.user.role==="superuser") &&
            <>
              <TextField
                fullWidth
                variant="outlined"
                label="Empresa"
                value={this.state.company_id}
                onChange={(e) => this.setState({ company_id: e.target.value })}
                required
              />
              <D h="1rem" />
            </>
          }
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Sexo</InputLabel>
            <Select
              labelId="select-C.GenderType"
              id="select-gt"
              value={this.state.gender}
              label="Sexo"
              onChange={(e) => this.setState({gender: e.target.value})}
            >
              {Object.keys(C.GenderType).map(key => {
                  return <MenuItem key={key} value={key}>{C.GenderType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Celular (xx) xxxxx-xxxx"
            value={this.state.mobile}
            onChange={(e) => this.setState({ mobile: this.phoneMask(e.target.value) })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Celular Alternativo (xx) xxxxx-xxxx"
            value={this.state.mobile2}
            onChange={(e) => this.setState({ mobile2: this.phoneMask(e.target.value) })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="CEP xxxxx-xxx"
            value={this.state.cep}
            onChange={(e) => this.setState({ cep: this.cepMask(e.target.value) })}
            required
          />
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Endereço"
            value={this.state.address}
            onChange={(e) => this.setState({ address: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Cidade"
            value={this.state.city}
            onChange={(e) => this.setState({ city: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Estado"
            value={this.state.state}
            onChange={(e) => this.setState({ state: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="CPF xxx.xxx.xxx-xx"
            value={this.state.cpf}
            onChange={(e) => this.setState({ cpf: this.cpfMask(e.target.value,true) })}
            error={this.state.invalid_cpf}
            helperText={this.state.invalid_cpf ? "CPF inválido" : ""}
            required
          />
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Profissão"
            value={this.state.profession}
            onChange={(e) => this.setState({ profession: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Estado Civil</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.maritalstatus}
              label="Estado Civil"
              onChange={(e) => this.setState({maritalstatus: e.target.value})}
            >
              {Object.keys(C.MaritalStatusType).map(key => {
                  return <MenuItem key={key} value={key}>{C.MaritalStatusType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>          
          <D h="1rem" /> 
          <Paper style={{padding: '0.5rem'}} sx={{backgroundColor: (this.state.age < 18) ? "#f5f9fd" : "white"}} elevation={(this.state.age < 18) ? 1 : 0}>        
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DatePicker 
              label="Data de Nascimento"
              onChange={this.handleDateChange}
              value={dayjs(this.state.birthday,'DD/MM/YYYY')}               
              slotProps={{ textField: { fullWidth: true, required: true } }}
              sx={{ width: "100%" }}
            />
            </LocalizationProvider> 
            {(this.state.age < 18) && <>
              <D h="0.4rem" />
              <Stack direction="row" spacing={2} style={{padding: '1rem'}}>
                <FamilyRestroom color="primary" />
                <Typography variant="button" gutterBottom sx={{ display: 'block' }} color="primary">Paciente Menor de Idade</Typography>
              </Stack>
              <D h="1rem" />

              <TextField
                fullWidth
                variant="outlined"
                label="Nome do Responsável Legal"
                value={this.state.legalname}
                onChange={(e) => this.setState({ legalname: e.target.value })}
                required
              />
              <D h="1rem" /> 
              <TextField
                fullWidth
                variant="outlined"
                label="CPF do Responsável Legal"
                value={this.state.legalcpf}
                onChange={(e) => this.setState({ legalcpf: this.cpfMask(e.target.value,false) })}
                error={this.state.invalid_cpf_legalrepresentative}
                helperText={this.state.invalid_cpf_legalrepresentative ? "CPF inválido" : ""}
                required
              />
              <D h="1rem" />              
              <FormControl fullWidth>
                <InputLabel id="select-type">Estado Civil do Responsável Legal</InputLabel>
                <Select
                  labelId="select-type"
                  id="select-rl"
                  value={this.state.legalmaritalstatus}
                  label="Estado Civil"
                  onChange={(e) => this.setState({legalmaritalstatus: e.target.value})}
                >
                  {Object.keys(C.MaritalStatusType).map(key => {
                      return <MenuItem key={key} value={key}>{C.MaritalStatusType[key]}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>          
              <D h="1rem" />  
              <TextField
                fullWidth
                variant="outlined"
                label="Profissão do Responsável Legal"
                value={this.state.legalprofession}
                onChange={(e) => this.setState({ legalprofession: e.target.value })}
                required
              />
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Cidade do Responsável Legal"
                value={this.state.legalcity}
                onChange={(e) => this.setState({ legalcity: e.target.value })}
                required
              />
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Estado do Responsável Legal"
                value={this.state.legalstate}
                onChange={(e) => this.setState({ legalstate: e.target.value })}
                required
              />
              <D h="1rem" />  
            </>}   
          </Paper>
          <D h="1rem" />
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.allow_contact} 
              onChange={(e) => this.setState({ allow_contact: e.target.checked })} 
            />
          } label="Permito contatos pelos canais digitais" />
          <D h="1 rem" />
          <Paper style={{padding: '0.5rem'}} sx={{backgroundColor: "#f5f9fd"}}>
          <Stack direction="row" spacing={2} style={{padding: '1rem'}}>
            <MedicalServices color="primary" />
            <Typography variant="button" gutterBottom sx={{ display: 'block' }} color="primary">Em Caso de Emergência:</Typography>
          </Stack>          
          <D h="1 rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Em Caso de Emergência Contactar"
            value={this.state.emergencyname}
            onChange={(e) => this.setState({ emergencyname: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Telefone do Contato de Emergência"
            value={this.state.emergencyphone}
            onChange={(e) => this.setState({ emergencyphone: this.phoneMask(e.target.value) })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Convênio Médico"
            value={this.state.health_insurance}
            onChange={(e) => this.setState({ health_insurance: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Número do Cartão do Convênio Médico"
            value={this.state.card}
            onChange={(e) => this.setState({ card: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Hospital para Encaminhamento"
            value={this.state.hospital}
            onChange={(e) => this.setState({ hospital: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Médico de Emergência"
            value={this.state.doctor}
            onChange={(e) => this.setState({ doctor: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Telefone do Médico"
            value={this.state.doctor_phone}
            onChange={(e) => this.setState({ doctor_phone: this.phoneMask(e.target.value) })}
          />          
          </Paper>
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit" disabled={this.state.invalid_cpf}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}











/***************************************************************************************
 ***************************************************************************************
 
 From Survey.jsx - avoid import and usage of authenticated API
 
 ***************************************************************************************
***************************************************************************************/

class Survey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_id: this.props.patient_id ? this.props.patient_id : -1, 
      procedure_id: this.props.procedure_id ? this.props.procedure_id : -1,
      questionnaire_id: this.props.questionnaire_id ? this.props.questionnaire_id : -1,
      company_id: this.props.company_id ? this.props.company_id : -1,
      type: this.props.document_type ? this.props.document_type : -1,
      hash: this.props.hash ? this.props.hash : '',
      ip: this.props.ip ? this.props.ip : '',
      training_patient: this.props.training_patient ? this.props.training_patient : false,
      treatment_id: this.props.treatment_id ? this.props.treatment_id : -1,
      price: this.props.price ? this.props.price : '',
      survey: null,
      
    };
  }
  
  
  componentDidMount() {
    this.setState({ loading: true });
    this.props.api
      .get('/Survey/' + this.state.procedure_id + '/' + this.state.questionnaire_id)
      .then((r) => { 
        this.setState({
          loading: false,
          survey: r.data.survey,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }


  handleSubmit = () => {   
    var answers = []
    for(let s in this.state.survey){
      let item = []
      item.push(this.state.survey[s].question_id);
      item.push(this.state.survey[s].user_selection);
      item.push(this.state.survey[s].user_complement);
      answers.push(item);
    }

    this.props.api
      .post("candidate_step2/" + this.state.hash + "/" + this.state.ip, { patient_id: this.state.patient_id, treatment_id: this.state.treatment_id, training_patient: this.state.training_patient, price:this.state.price, company_id: this.state.company_id, type: this.state.type, questionnaire_id: this.state.questionnaire_id, answers: answers })
      .then((r) => {
        this.props.dialogClose();
        if("error" in r)
          this.props.alert(r.error);
        else
          this.props.alert('Pré-anamnese realizada com sucesso');
      })
      .catch(() => this.props.alert('Ocorreu um erro ao criar a pré-anamnese'));
  }


  handleChangeInQuestion = (survey_index,question_id, type, user_complement, user_selection) => {
      if(this.state.survey[survey_index].question_id === question_id){
        var s = this.state.survey;
        s[survey_index].user_selection = (user_selection ? user_selection : []);
        s[survey_index].user_complement = (user_complement ? user_complement : null);
        this.setState({survey: s});
      }
  }
 
  
  render() {
    return (
      <form onSubmit={this.handleSubmit} method="GET">
        <input type="hidden" name="r" value={this.state.hash} /> 
        
        <DialogTitle style={{ minWidth: '400px' }}>
          {C.DocumentType[this.state.type]}
        </DialogTitle>
        <DialogContent>        
          <Stack>
          {          
            this.state.survey && this.state.survey.map( (s,index) => {
              return(
                  <D key={s.question_id}>                
                  {(s.type === 1) &&
                    <QuestionRadioButton                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                      horizontal={true}
                    />
                  }
                  {(s.type === 2) &&
                    <QuestionSlidebar                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                    />
                  }
                  {(s.type === 3) &&
                    <QuestionCheckbox                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                    />
                  }
                  {(s.type === 4) &&
                    <QuestionEditbox                  
                      question_id={s.question_id}
                      type={s.type}
                      label={s.label}
                      label_asking_complement={s.label_asking_complement} 
                      user_complement={s.user_complement} 
                      user_selection={s.user_selection}
                      choice={s.choice}
                      survey_index={index}
                      onChange={this.handleChangeInQuestion}
                      horizontal={false}
                    />
                  } 
                  <D h="1rem" /><Divider/><D h="1rem" />
                </D>
              );
            }) 
          }
          </Stack>
          
          <D h="1rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" type="button" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export { ColectData };
